"use strict";
exports.__esModule = true;
exports.FluidLegend = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var LegendList_1 = require("./LegendList");
var helpers_1 = require("./helpers");
/**
 * @internal
 */
var FluidLegend = /** @class */ (function (_super) {
    tslib_1.__extends(FluidLegend, _super);
    function FluidLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showAll: false
        };
        _this.toggleShowAll = function () {
            _this.setState({
                showAll: !_this.state.showAll
            });
        };
        _this.renderSeries = function (itemWidth, visibleItemsCount) {
            var _a = _this.props, series = _a.series, _b = _a.onItemClick, onItemClick = _b === void 0 ? noop_1["default"] : _b, enableBorderRadius = _a.enableBorderRadius;
            var limit = _this.state.showAll ? series.length : visibleItemsCount;
            var pagedSeries = series.slice(0, limit);
            return (react_1["default"].createElement("div", { className: "series" },
                react_1["default"].createElement(LegendList_1.LegendList, { enableBorderRadius: enableBorderRadius, series: pagedSeries, onItemClick: onItemClick, width: itemWidth })));
        };
        _this.renderPaging = function () {
            var classes = classnames_1["default"]("gd-button-link", "gd-button-icon-only", "paging-button", {
                "gd-icon-chevron-up": _this.state.showAll,
                "gd-icon-chevron-down": !_this.state.showAll
            });
            return (react_1["default"].createElement("div", { className: "paging" },
                react_1["default"].createElement("button", { className: classes, onClick: _this.toggleShowAll })));
        };
        return _this;
    }
    FluidLegend.prototype.render = function () {
        var _a = this.props, series = _a.series, containerWidth = _a.containerWidth;
        var _b = helpers_1.calculateFluidLegend(series.length, containerWidth), itemWidth = _b.itemWidth, hasPaging = _b.hasPaging, visibleItemsCount = _b.visibleItemsCount;
        return (react_1["default"].createElement("div", { className: "viz-legend fluid" },
            this.renderSeries(itemWidth, visibleItemsCount),
            hasPaging && this.renderPaging()));
    };
    return FluidLegend;
}(react_1["default"].PureComponent));
exports.FluidLegend = FluidLegend;
//# sourceMappingURL=FluidLegend.js.map